import React from 'react';
import styled from 'styled-components';


const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5em;
    ${({ align }) => align ? 'align-items: ' + align + ';' : null}
    ${({ justify }) => justify ? 'justify-content: ' + justify + ';' : null}
`

const Row = ({ children, ...props }) => {

    return (
        <Wrapper {...props}>
            {children}
        </Wrapper>
    );
}

export default Row;
